module.exports = __webpack_public_path__ + "img/faqs_cold_weather_tips_fr.8cb7ac1f.webp";